const SECRET_KEY = "secret";
const REFRESH_KEY = "refreshkey";
const RESET_KEY = "reset";
const MAIL_HOST = "mail.briskbusiness.co.ke";
const MAIL_PORT = "587";
const MAIL_USER = "alerts@briskbusiness.co.ke_none";
const MAIL_PASS = "?Bsl@#2024_none";
const API_CLIENT_ID = "410";
const SERVICE_ID = "232514";
const SECRET = "vCODlKDfRMDfvxY8OvRN3heVd71W0wj/";
const KEY = "Cn8L7rjl8c5ppU+7";
const RECAPTCHA_SECRET_KEY = "6LfCSboqAAAAAFHDq2S3cSw-9LDbc6q7Sn54b0sT";
export {
  API_CLIENT_ID as A,
  KEY as K,
  MAIL_USER as M,
  RESET_KEY as R,
  SERVICE_ID as S,
  SECRET as a,
  SECRET_KEY as b,
  REFRESH_KEY as c,
  RECAPTCHA_SECRET_KEY as d,
  MAIL_PASS as e,
  MAIL_HOST as f,
  MAIL_PORT as g
};
